import { render, staticRenderFns } from "./BlacklistModal.vue?vue&type=template&id=701d9217&scoped=true"
import script from "./BlacklistModal.vue?vue&type=script&lang=js"
export * from "./BlacklistModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "701d9217",
  null
  
)

export default component.exports